module.exports = __webpack_public_path__ + "img/group239.09a124a5.png";